module.exports = __webpack_public_path__ + "img/app11.3c32e911.png";